import theme, { createStyles } from 'core/utilities/theme';

export default createStyles({
  disabled: {
    color: theme.palette.text.disabled,
    cursor: 'text',
    '& a': {
      color: theme.palette.text.disabled,
      textDecoration: 'none',
      pointerEvents: 'none',
    },
  },
  withDarkBackgroundColor: {
    '& *': {
      color: 'white',
    },
  },
});
